import { c as _c } from "react/compiler-runtime";
import { FlexColumn, IconCallout, ModalBody, ModalFooter, TextBody, TextHeading } from "@opensea/ui-kit";
export function FeesContentLayout(t0) {
  const $ = _c(18);
  const {
    icon: Icon,
    title,
    body,
    walletStatus,
    footer
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <IconCallout icon={Icon} size={24} variant="outlined" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <TextHeading size="md">{title}</TextHeading>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== body) {
    t3 = <TextBody color="text-secondary" size="md">{body}</TextBody>;
    $[4] = body;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <FlexColumn className="items-center gap-2">{t1}{t2}{t3}</FlexColumn>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== walletStatus) {
    t5 = <ModalBody className="py-6 text-center"><FlexColumn className="items-center gap-6">{t4}{walletStatus}</FlexColumn></ModalBody>;
    $[10] = t4;
    $[11] = walletStatus;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== footer) {
    t6 = <ModalFooter>{footer}</ModalFooter>;
    $[13] = footer;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}